import { z } from "zod";

/**
 * Schema for validating email input
 * Used for email verification and email update
 */
export const emailFormSchema = z.object({
  email: z.string().email({ message: "Please provide a valid email address." }),
});
